const RECEIPT_STATUS_FIELD = 'receiptStatus';
const RECEIPT_STATUS_UNSET_VALUE = 'None';
const GXO_TRANSFER_TO_NAME = 'GXO';

// receiptStatus is an optional field: it's either absent from the API response
// entirely, or present with the sentinel value 'None' - the API never sends an
// empty string for it. Filtering on this server-side via OData $filter isn't
// safe, since the backend errors out the whole query when it doesn't
// recognize/support the property yet - so this is applied client-side, after
// orders are fetched.
const hasReceiptStatus = (order) => {
  const value = order?.[RECEIPT_STATUS_FIELD];
  return value !== undefined && value !== null && value !== RECEIPT_STATUS_UNSET_VALUE;
};

const isGxoDestination = (order) => {
  const transferToName = order?.transferToName;
  return typeof transferToName === 'string' && transferToName.includes(GXO_TRANSFER_TO_NAME);
};

// Transfer orders with a receiptStatus set are hidden from vendors - in lists,
// search, exports and uploads alike - unless they're being transferred to GXO.
export const isVisibleToVendor = (order) => !hasReceiptStatus(order) || isGxoDestination(order);

// Purchase orders aren't affected by this rule; transfer orders are filtered
// down to the ones visible to the vendor.
export const filterOrdersForVendor = (orders, type) =>
  type === 'purchase' ? orders : orders.filter(isVisibleToVendor);
